import { TableFiltersState } from 'types/common';
import { Switch } from '../Switch';
import { useCallback } from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';

interface Props {
    isActive?: boolean;
    disabled?: boolean;
    label?: string;
    onChange: (activeStatus: boolean) => void;
}

export const TableSwitch = ({ isActive = false, disabled, label, onChange }: Props) => {
    const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        onChange(checked);
    }, []);

    return (
        <FormControlLabel
            label={label}
            labelPlacement="start"
            sx={{ mx: 0 }}
            control={<Switch size="small" checked={isActive} disabled={disabled} onChange={handleChange} />}
        />
    );
};
